// @ts-nocheck
import { BreakpointValue, BreakpointValueProp } from "@store/Framework/Common/Utilities/breakpointValues";
import getCleanBreakpointValues from "@store/Framework/Common/Utilities/getCleanBreakpointValues";
import getFullBreakpointValues from "@store/Framework/Common/Utilities/getFullBreakpointValues";
import { TypeOfArray } from "@toolkit/Framework/Types/Common";

const mergeBreakpointValues = <T extends BreakpointValueProp<any>, U = Exclude<TypeOfArray<T>, null>>(
    values1: T,
    values2: T,
    transform: (value1: U, value2: U) => BreakpointValue<U>,
    cleanBreakpointValues = true,
    breakpointCount = 5,
) => {
    const breakpointValues1 = getFullBreakpointValues(values1, breakpointCount);
    const breakpointValues2 = getFullBreakpointValues(values2, breakpointCount);

    if (!breakpointValues1) {
        return breakpointValues2;
    }

    if (!breakpointValues2) {
        return breakpointValues1;
    }

    const result = breakpointValues1.map((value1, i) => {
        const value2 = breakpointValues2[i];

        if (value1 === null) {
            return value2;
        }

        if (value2 === null) {
            return value1;
        }

        return transform(value1 as U, value2 as U);
    });

    return cleanBreakpointValues ? getCleanBreakpointValues(result) : result;
};

export default mergeBreakpointValues;
